import "core-js/modules/es.object.from-entries.js";
function _array_like_to_array(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _array_with_holes(arr) {
  if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _non_iterable_rest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
  return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _array_like_to_array(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { useLocation } from "@custom/schema";
import { zodResolver } from "@hookform/resolvers/zod";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { getDomain, useDomain } from "./domain";
import { useLocale } from "./localization";
import { getLocalizedUrl } from "./url";
var searchParameters = z.object({
  search: z.string().optional().default(""),
  domain: z.string().optional().transform(function (v) {
    return v;
  })
});
export var useSearchParameters = function useSearchParameters() {
  var _useLocation = _sliced_to_array(useLocation(), 2),
    location = _useLocation[0],
    navigate = _useLocation[1];
  var locale = useLocale();
  return [searchParameters.parse(Object.fromEntries(location.searchParams.entries())), function (params) {
    navigate(getLocalizedUrl({
      to: "/search",
      locale: locale,
      domain: getDomain(params.domain)
    }).url, params);
  }];
};
export var useSearchForm = function useSearchForm() {
  var _useSearchParameters = _sliced_to_array(useSearchParameters(), 2),
    parameters = _useSearchParameters[0],
    runSearch = _useSearchParameters[1];
  var domain = useDomain();
  var _useForm = useForm({
      resolver: zodResolver(searchParameters),
      defaultValues: {
        domain: domain.id === "paraplegie_ch" ? undefined : domain.id
      }
    }),
    register = _useForm.register,
    handleSubmit = _useForm.handleSubmit,
    setValue = _useForm.setValue;
  useEffect(function () {
    setValue("search", parameters.search);
    var _parameters_domain;
    setValue("domain", domain.id === "paraplegie_ch" ? parameters.domain : (_parameters_domain = parameters.domain) !== null && _parameters_domain !== void 0 ? _parameters_domain : domain.id);
  }, [parameters.domain, parameters.search, setValue, domain.id]);
  return [handleSubmit(function (input) {
    runSearch(input);
  }), register];
};